var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomFormBaseElement',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.handleCustomFormBaseElementInput}})}
var staticRenderFns = []

export { render, staticRenderFns }